import { SystemActionsList } from '@wix/editor-platform-host-integration-apis';
import { ContributedEditActionsDict } from '../types';
import { upgradeActionFactory } from './upgradeActionFactory';

export const systemActions: ContributedEditActionsDict = {
  [SystemActionsList.upgrade]: upgradeActionFactory,
};
